import { weddingIcon } from "./icons/wedding.js";
import { birthdayIcon } from "./icons/birthday.js";
import { corporateIcon } from "./icons/corporate.js";
import { otherIcon } from "./icons/other.js";
/**
 * Dynamic lookup map — use this when the icon name comes from config/data
 * at runtime (e.g. mapping EventTypeDJK to an icon).
 *
 * **Achtung:** Importiert alle Icons. Für optimales Tree-Shaking
 * stattdessen die Named Exports direkt importieren:
 *
 * ```typescript
 * // Tree-shakeable (empfohlen für Apps mit wenigen Icons)
 * import { weddingIcon } from "@progressive-development/pd-icon-events";
 *
 * // Dynamischer Lookup (wenn Icon-Name aus Config kommt)
 * import { eventIconMap } from "@progressive-development/pd-icon-events";
 * const icon = eventIconMap.get("wedding");
 * ```
 */
export const eventIconMap = new Map([
    ["wedding", weddingIcon],
    ["birthday", birthdayIcon],
    ["businessparty", corporateIcon],
    ["other", otherIcon],
]);
//# sourceMappingURL=event-icon-map.js.map